module.exports = __webpack_public_path__ + "img/event.19f9dfc9.svg";